var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.background},[_c('icon',{attrs:{"name":"rings-background"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }